/** Where readers are pointed when the archive itself is at fault. */
export const SUPPORT_EMAIL = 'support@tara.media'
